import React from 'react'
import { useSelector } from 'react-redux'
import { LoadingBar } from './LoadingBar'

const GlobalLoadingBar = () => {
  const showLoadingBar = useSelector(({ loadingBar }) => loadingBar.isLoading)
  return showLoadingBar && <LoadingBar />
}

export { GlobalLoadingBar }
